/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

    const getPlateStatus = (status: number): string => {
        switch (status) {
          case 1:
            return "NEW";
          case 2:
            return "LAB INPROGRESS";
          case 3:
            return "LAB APPROVED";
          case 4:
            return "LAB REJECTED";
          case 5:
            return "PERSONNEL MONITORING INPROGRESS";
          case 6:
            return "PERSONNEL MONITORING APPROVED";
          case 7:
            return "PERSONNEL MONITORING REJECTED";
          case 8:
            return "EP INPROGRESS";
          case 9:
            return "EXPOSED PLATE";
          case 10:
            return "EP REJECTED";
          case 12:
            return "INCUBATION INPROGRESS";
          case 13:
            return "INCUBATION COMPLETED";
          case 14:
            return "AUTOCLAVE INPROGRESS";
          case 15:
            return "AUTOCLAVE COMPLETED";
          case 16:
            return "EXCEPTION REQUESTED";
          case 17:
            return "DAMAGED";
          case 18:
            return "DISCARDED";
          case 19:
            return "EXCEPTION REJECTED";
          case 20:
            return "LAB INPROGRESS";
          case 21:
            return "LAB COMPLETED";
          case 22:
            return "LAB APPROVED";
          case 23:
            return "LAB REJECTED";
          case 24:
            return "PLATE SAMPLING";
          case 25:
            return "PLATE MATERIAL TEST INPROGRESS";
          case 26:
            return "PLATE MATERIAL TEST COMPLETED";
          case 27:
            return "PLATE MULTIPLE INCUBATION INPROGRESS";
          case 28:
            return "CONTACT PLATE MONITORING INPROGRESS";
          case 29:
            return "CONTACT PLATE MONITORING COMPLETED";
          case 30:
            return "ENVIRONMENTAL FLORA COMPLETED";
          case 31:
           return "SURFACE MONITORING - SWAB COLLECTION INPROGRESS";
          case 32:
           return "ENVIRONMENTAL FLORA SKIPPED";
          case 33:
           return "PLATE GLOVE PORT MONITORING INPROGRESS";
          case 34:
           return "PLATE GLOVE PORT MONITORING COMPLETED";
          case 35:
           return "PLATE ENVIRONMENT FLORA COMPLETED";
          case 38:
           return "PLATE ANAEROBIC MONITORING INPROGRESS";
          case 39:
           return "PLATE ANAEROBIC MONITORING COMPLETED";
          case 40:
           return "PLATE NITROGEN MONITORING INPROGRESS";
          case 41:
           return "PLATE NITROGEN MONITORING COMPLETED";
          case 42:
           return "PLATE COMPRESSED AIR MONITORING INPROGRESS";
          case 43:
           return "PLATE COMPRESSED AIR MONITORING COMPLETED";
          default:
            return "UNKNOWN STATUS";
        }
    };

    const getQAStatus = (statusName: string): string => {
      switch (statusName) {
        case 'NOT APPROVED':
          return 'Lab Pending';
        case 'IN PROGRESS':
          return 'Waiting for Lab Approval';
        case 'APPROVED':
          return 'Lab Approved';
        case 'REJECTED':
          return 'Lab Rejected';
        default:
          return 'Unknown Status';
      }
    };

    const plateType = (statusName: number): string => {
      switch (statusName) {
        case 1:
          return 'Q A Plate';
        case 2:
          return 'Exposure Plate';
        case 3:
          return 'Personnel Monitoring Plate';
        case 4:
          return 'Sampling Plate';
        case 5:
          return 'Material Test Plate'
        case 6:
          return 'Contact Plate Monitoring Plate';
        case 7:
          return 'Surface Monitoring - SWAB Collection'
        default:
          return 'Unknown Status';
      }
    };

    const plateBatchStatus = (statusName: string): string => {
      switch (statusName) {
        case "5":
          return 'Waiting for Lab Approval';
        case "1":
          return 'Lab Approved';
        case "2":
          return 'Ready To Use';
        case "3":
          return 'Activity Inprogress';
        case "4":
          return 'Lab Rejected'
        case "0":
          return 'Quarantine';
        case "6":
          return 'Discard'
        default:
          return 'Unknown Status';
      }
    };


  //get all plate list
  const getPlateList = async (page :number, size :number, sort :string, order : string, status: number, keyWord: any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=${status}&keyword=${keyWord}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const listPlateBatch = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_batch`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listSerialNumber = async (batchId?: string, lotId?: string, batchNo?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_serial?status=active&batch_id=${batchId || ""}&batch_no=${batchNo || ""}&lot_id=${lotId || ""}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getExceptionPlates = async (page :number, size :number, sort :string, order : string, status: string, keyWord: any, reasonId: any, x_auth_token: string, x_user_id: string, scheduleProductId?: string, productId?: string , serialNumber?: string) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_exception?page=${page}&size=${size}&sort=${sort}&order=${order}&exception_status=16&status=${status}&keyword=${keyWord}&reason_id=${reasonId}&schedule_production_id=${scheduleProductId}&product_id=${productId}&serial_number=${serialNumber}`, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const getExceptionPlateHistory = async (page :number, size :number, sort :string, order : string, status: string, keyWord: any, reasonId: any, x_auth_token: string, x_user_id: string, scheduleProductId?: string, productId?: string) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_exception?page=${page}&size=${size}&sort=${sort}&order=${order}&exception_status=17,19&status=${status}&keyword=${keyWord}&reason_id=${reasonId}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,{ headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const getPlateDetailsBySerielNo = async (serial_number : string, process : string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/empats/get_plate_slno?serial_number=${serial_number}&process=${process}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }
  
  const getExceptionReasons = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_exception_reason?status=active`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getVisualInspectionStatus = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lots/list_visual_inspection_statuses?status=active`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getSamplingTestType = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_sampling_test_type?status=active&sort=test_type&order=asc`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getRawMaterialType = async () => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_raw_material_type?status=active&sort=material_type&order=asc`,{headers});
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const addPlateException = async (dataToSend : any , x_auth_token: string, x_user_id: string) => {
    try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/plates/add_plate_exception`, 
        dataToSend, { headers }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const changeExceptionStatus = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/plate_exception_status_change`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListPlateDetails = async (page :number, size :number, sort :string, order: string, status: string, keyWord: any, current_location_id : any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&plate_status=${status}&keyword=${keyWord}&current_location_id=${current_location_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListPlateByStatus = async (page :number, size :number,sort :string, order : string, plate_status:string, locationId:any, keyword:any, location: any, master_activities_id?:any, next_process?:any, next_equipment_id?: string, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&plate_status=${plate_status}&keyword=${keyword}&current_location_id=${locationId}&area_id=${location}&master_activities_id=${master_activities_id}&next_process_keyword=${next_process}&next_equipment_id=${next_equipment_id}&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listPlateBySerielNo =async (serial_number : string, location_id : any, process: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=1&size=10&sort=id&order=asc&status=active&serial_number=${serial_number}&process=${process}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

 const listAutoClavePlateBySerielNo =async (serial_number : string, process : string, areaId ? : string) => {
  const dataToSend = {
    "serial_number" : serial_number,
    "process" : process,
    "equipment_location_id" : areaId
  }
    try {
      const response = await axiosInstance.post(`${baseUrl}/scan/plate`,
      dataToSend,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const startPlateIncubation = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/start_plate_incubation`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const endPlateIncubation = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/stop_plate_incubation`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const startPlateLabTest = async (dataToSend : any , x_auth_token:string , x_user_id:string) => {
    try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/plates/start_lab_test`, dataToSend , { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getLabApprovedPlates =  async (page :number, size :number, keyword:any, activityTypeId: any, areaId: any, batchCode: any, fromDate: any, toDate: any,sort:any,order:any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lab/list_plates?page=${page}&size=${size}&sort=${sort}&order=${order}&batch_number=${batchCode}&area_master_id=${areaId}&activity_type_id=${activityTypeId}&serial_number=&keyword=${keyword}&start_date_time=${fromDate}&completed_date_time=${toDate}&completed_by=&approved_by=&final_test=true&next_process_keyword=LabApproval&lab_completed_from_date&lab_completed_to_date&lab_approved_from_date&lab_approved_to_date&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

    const getFloraLabApprovedPlates =  async (page :number, size :number,sort:any,order:any, keyword:any, activityTypeId: any, areaId: any, batchCode: any, fromDate: any, toDate: any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plate_environmental_flora/list_flora_initiated_plates?page=${page}&size=${size}&sort=${sort}&order=${order}&batch_number=${batchCode}&area_master_id=${areaId}&activity_type_id=${activityTypeId}&serial_number=&keyword=${keyword}&activity_start_date_time=${fromDate}&activity_end_date_time=${toDate}&completed_by=&approved_by=&final_test=true&lab_completed_from_date&lab_completed_to_date&lab_approved_from_date&lab_approved_to_date&schedule_production_id=${scheduleProductId}&product_id=${productId}&plate_status=30`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getLabPlatesHistory =  async (page :number, size :number,sort:any,order:any, keyword:any, activityTypeId: any, areaId: any, batchCode: any, fromDate: any, toDate: any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lab/list_plates?page=${page}&size=${size}&sort=${sort}&order=${order}&batch_number=${batchCode}&area_master_id=${areaId}&activity_type_id=${activityTypeId}&serial_number=&keyword=${keyword}&start_date_time=${fromDate}&completed_date_time=${toDate}&completed_by=&approved_by=&lab_status=22,23&final_test=true&lab_completed_from_date&lab_completed_to_date&lab_approved_from_date&lab_approved_to_date&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

    const getFloraLabPlatesHistory =  async (page :number, size :number,sort:any,order:any, keyword:any, activityTypeId: any, areaId: any, batchCode: any, fromDate: any, toDate: any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plate_environmental_flora/list_flora_initiated_plates?page=${page}&size=${size}&sort=${sort}&order=${order}&batch_number=${batchCode}&area_master_id=${areaId}&activity_type_id=${activityTypeId}&serial_number=&keyword=${keyword}&activity_start_date_time=${fromDate}&activity_end_date_time=${toDate}&completed_by=&approved_by=&plate_status=35&final_test=true&lab_completed_from_date&lab_completed_to_date&lab_approved_from_date&lab_approved_to_date&schedule_production_id=${scheduleProductId}&product_id=${productId}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const scanPlateById = async (dataToSend :any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/scan/plate`, dataToSend ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const changeLabReportStatus = async (dataToSend :any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/stop_lab_test`, dataToSend ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

    const changeFloraReportStatus = async (dataToSend :any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/stop_plate_environmental_flora_details`, dataToSend ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }
    const changeQAReportStatus = async (dataToSend :any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/production/change_approval_status`, dataToSend ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListAutoclaveDetails = async (page :number, size :number, sort :string, order : string, status: any, keyWord: any, serial_number:any, current_location_Id:any, master_activities_id?:any, next_process?:any, equipment_id?:string, scheduleProductId?: string, productId?: string,batchNumber?:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&plate_status=${status}&keyword=${keyWord}&batch_number=${batchNumber}&serial_number=${serial_number}&current_location_id=${current_location_Id}&master_activities_id=${master_activities_id}&next_process_keyword=${next_process || ""}&assigned_autoclave=${equipment_id || ""}&schedule_production_id=${scheduleProductId || ""}&product_id=${productId || ""}` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListLabTestHistory = async (page :number, size :number, sort :string, order : string, keyword:any, location: any, batchCode: any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/stat_activity/lab_history?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&area_master_id=${location}&batch_code=${batchCode}&schedule_production_id=${scheduleProductId}&product_id=${productId}` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListIncubationHistory =  async (page :number, size :number,sort :string, order : string, keyword:any, areaId:any, scheduleProductId?: string, productId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/stat_activity/incubation_history?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&area_master_id=${areaId}&schedule_production_id=${scheduleProductId}&product_id=${productId}` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListAutoclaveHistory =  async (page :number, size :number,sort :string, order : string, keyword:any, areaId:any, activityId:any, scheduleProductId?: string, productId?: string, batchNumber?:string,serial_number?:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/stat_activity/autoclave_history?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active&keyword=${keyword}&batch_number=${batchNumber}&serial_number=${serial_number}&area_master_id=${areaId}&activity_id=${activityId}&schedule_production_id=${scheduleProductId || ""}&product_id=${productId || ""}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const createPlate = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/create_new_plates`, 
       dataToSend ,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    }catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
  }

  const createPlateV2 = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/v3/create_new_plates`, 
       dataToSend ,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    }catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
  }


  const createTestTube = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/test_tubes/save`, 
       dataToSend ,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    }catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
  }

  const createSwabStick = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/swabs/save`, 
       dataToSend ,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    }catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
  }


  const listAllPlateTypes =  async (activityWorkFlowId?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_plate_types?status=active&activity_workflow_id=${activityWorkFlowId || ""}` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const getMediaType =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_all_media_types` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listAllTestTubeTypes =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master_test_tubes/list_all_test_tube_types?sort=id&order=asc&page=1&size=10&status=active` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listAllPlateGrades =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_plate_grades?status=active`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listAllFingerDabTypes =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_finger_dab_option?status=active,inactive` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listFingerDabAssessmentTypes =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_fingerdab_assesment_types?status=active`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listNextPlateSerial =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/get_next_plate_serial`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listNextTestTubeSerial =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/test_tube/get_next_test_tube_serial`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listNextSwabStickSerial =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/swabs/get_next_test_tube_serial`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const assignSamplingPlates = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/assign_sampling_plates`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const assignNoTest = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/no_test`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const assignRawMaterialTest = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/plates/start_raw_material_test`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const plateBulkUpload = async (dataToSend:any) => {
    try {
      const formData = new FormData();
      formData.append('file', dataToSend); // 'file' should match the name expected by the API
  
      const response = await axiosInstance.post(`${baseUrl}/files/v2/import_plate_details`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data', 
            'x-auth-token': authToken,
            'x-userid': authUserID
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getRawMaterialSubCtegory = async (material_id : string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_raw_material_sub_type?sort=name&order=asc&status=active&material_type_id=${material_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListLots = async (page :number, size :number, sort :string, keyWord: any, batch_id : any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?page=${page}&size=${size}&sort=${sort}&order=asc&status=active&keyword=${keyWord}&inspection_status=pending&batch_no&lot_code=&batch_id=${batch_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listNextLotCode =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lots/get_next_lot_code`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listPlateByBatch =  async (batch_number: any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/plates/list_plate_details?page=1&size=10&sort=id&order=asc&status=active&plate_status=14&keyword=&batch_number=${batch_number}&serial_number=&current_location_id=&location=&incubator_id&lot_id&lot_code`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const createNewLot = async (dataToSend:any) => {
    try {  
      const response = await axiosInstance.post(`${baseUrl}/plates/create_new_lots`, 
        dataToSend,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const createLotQR = async (dataToSend:any) => {
    try {  
      const response = await axiosInstance.post(`${baseUrl}/plates/v2/generate_plate_qr_by_lot`, 
        dataToSend,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const generateQrCodeByLot = async (dataToSend:any) => {
    try {  
      const response = await axiosInstance.post(`${baseUrl}/plates/v2/generate_plate_qr_by_lot`, 
        dataToSend,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const ListLotsReconcilation = async (sort :string, keyWord: any, batch_id : any, lot_id:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?sort=${sort}&order=asc&status=active&keyword=${keyWord}&inspection_status=&batch_no&lot_code=&batch_id=${batch_id}&lot_id=${lot_id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listColonyTypes = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_colony_types?sort=id&order=desc&size&page`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const getActivityTypeList = async () => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/master_activities/list?sort=id&status=active&order=asc`,
        {
          headers: {
            "x-auth-token": authToken,
            "x-userid": authUserID,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data;
      }
    }
  };

  const updatePlateById = async (dataToSend:any) => {
    try {  
      const response = await axiosInstance.post(`${baseUrl}/plates/update`, 
        dataToSend,
        {
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          },
        }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  
  const userService = {
    getPlateList,
    getPlateStatus,
    listPlateBatch,
    listSerialNumber,
    getExceptionPlates,
    getExceptionPlateHistory,
    getPlateDetailsBySerielNo,
    getExceptionReasons,
    getVisualInspectionStatus,
    addPlateException,
    changeExceptionStatus,
    ListPlateDetails,
    ListPlateByStatus,
    listPlateBySerielNo,
    listAutoClavePlateBySerielNo,
    startPlateIncubation,
    endPlateIncubation,
    startPlateLabTest,
    getLabApprovedPlates,
    scanPlateById,
    getLabPlatesHistory,
    changeLabReportStatus,
    ListAutoclaveDetails,
    ListLabTestHistory,
    ListIncubationHistory,
    ListAutoclaveHistory,
    createPlate,
    createTestTube,
    listAllPlateTypes,
    listAllTestTubeTypes,
    listAllPlateGrades,
    listAllFingerDabTypes,
    listFingerDabAssessmentTypes,
    listNextPlateSerial,
    assignSamplingPlates,
    getSamplingTestType,
    plateBulkUpload,
    getRawMaterialType,
    assignRawMaterialTest,
    getRawMaterialSubCtegory,
    listNextTestTubeSerial,
    createPlateV2,
    ListLots,
    listNextLotCode,
    createNewLot,
    generateQrCodeByLot,
    createLotQR,
    listPlateByBatch,
    ListLotsReconcilation,
    listColonyTypes,
    getActivityTypeList,
    listNextSwabStickSerial,
    createSwabStick,
    getMediaType,
    getQAStatus,
    plateType,
    plateBatchStatus,
    updatePlateById,
    getFloraLabPlatesHistory,
    getFloraLabApprovedPlates,
    changeFloraReportStatus,
    assignNoTest,
    changeQAReportStatus

  };

  export { userService };
